<template>
  <div class="py-4 block-header">
    <h4 class="pt-4">{{ trans("courses.mission_scheduler.h4") }}</h4>
    <p class="pt-4">{{ trans("courses.mission_scheduler.p_first") }}</p>
    <h5 class="pt-4">{{ trans("courses.mission_scheduler.h5_first") }}</h5>
    <b-form-select v-model="selected" @change="onSelectedDay" class="mb-3">
      <b-form-select-option :value="threeDays">{{
        trans("courses.mission_scheduler.three_days")
      }}</b-form-select-option>
      <b-form-select-option :value="oneWeek">{{
        trans("courses.mission_scheduler.one_week")
      }}</b-form-select-option>
      <b-form-select-option :value="twoWeeks">{{
        trans("courses.mission_scheduler.two_weeks")
      }}</b-form-select-option>
    </b-form-select>
    <p>
      <small class="font-italic" v-if="this.selected">{{ getLocaleDateString }}</small>
    </p>

    <add-to-calendar
      v-if="this.selected"
      :title="trans('courses.mission_scheduler.calendar_title', { mission: chapterName })"
      :start="new Date()"
      :end="this.selected.date"
      :details="trans('courses.mission_scheduler.calendar_description', { mission: chapterName })"
      @click.native="trackMixpanelEvent()"
      inline-template
    >
      <div class="d-flex justify-content-center flex-column">
        <google-calendar class="pt-4 text-secondary btn text-left">
          {{ trans("courses.mission_scheduler.add_to") }} Google calendar
        </google-calendar>
        <microsoft-calendar class="pt-4 text-secondary btn text-left">
          {{ trans("courses.mission_scheduler.add_to") }} Microsoft live calendar
        </microsoft-calendar>
        <office365-calendar class="pt-4 text-secondary btn text-left">
          {{ trans("courses.mission_scheduler.add_to") }} Office365 outlook calendar
        </office365-calendar>
      </div>
    </add-to-calendar>

    <p class="py-4">{{ trans("courses.mission_scheduler.click_done") }}</p>
  </div>
</template>

<script>
export default {
  name: "MissionScheduler",
  props: {
    chapterName: String,
  },
  data() {
    return {
      selected: null,
      threeDays: null,
      oneWeek: null,
      twoWeeks: null,
    };
  },
  mounted() {
    this.getDates();
    this.selected = this.oneWeek;
    this.$emit("onSelectedDay", this.selected);
  },
  computed: {
    getLocaleDateString() {
      const options = { weekday: "long", year: "numeric", month: "long", day: "numeric" };
      return this.selected.date.toLocaleDateString(navigator.language, options);
    },
  },
  methods: {
    getDates() {
      Date.prototype.addDays = function (days) {
        let date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
      };

      let date = new Date();

      this.threeDays = { date: date.addDays(3), label: "3d" };
      this.oneWeek = { date: date.addDays(7), label: "1w" };
      this.twoWeeks = { date: date.addDays(14), label: "2w" };
    },
    trackMixpanelEvent() {
      trackEvent("DownloadMissionCalendar", {});
    },
    onSelectedDay() {
      this.$emit("onSelectedDay", this.selected);
    },
  },
};
</script>

<style lang="scss" scoped></style>
